import styled from '@emotion/styled'
import {theme} from '../Dashboard/theme'

export const HeroArea = styled.section`
  padding: 30px 20px 20px;
  max-width: 820px;
  margin: auto;
`

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px;
  font-family: ${theme.font.family};
`

export const PageSubtitle = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.5;
  font-family: ${theme.font.family};
`

export const ContentWrapper = styled.section`
  padding: 0 32px;

  @media (max-width: 600px) {
    padding: 0 16px;
  }
`

export const CardInner = styled.section`
  background: #ffffff;
  border-radius: 16px;
  max-width: 820px;
  margin: 0 auto;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  font-family: ${theme.font.family};
`

export const FormCard = styled.section`
  margin: 20px;
  border-radius: 10px;
  border: 2px solid rgb(244, 244, 244);
`

export const FormCardHeader = styled.section`
  display: flex;
  background: #f9fafb;
  margin-bottom: 20px;
  padding: 10px 20px;
  border-radius: 10px 10px 0 0;
`

export const SectionBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ff5000;
  background-color: rgba(255, 220, 204, 0.6);
  padding: 5px 10px;
  border-radius: 20px;
`

export const AccountDetailsBuildingIcon = styled.span`
  display: inline-flex;
  align-items: center;
  svg path {
    stroke: #ff5000;
  }
`

export const AccountDetailsWarning = styled.p`
  margin: -12px 20px 16px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff7ed;
  border-left: 3px solid #f97316;
  font-size: 12px;
  font-weight: 500;
  color: #9a3412;
  line-height: 1.5;
`

export const FormBody = styled.section`
  background: white;
  border-radius: 10px;
  padding: 10px 20px;
`

export const FormFooter = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 28px;
  border-top: 1px solid #e5e7eb;
`

export const StyledToggleWrapper = styled.div`
  background: #e1eaff;
`
